import { createContext, useState, useEffect } from "react";
import { getCodingOpportunitiesPatients } from "../../../utils/services/APP/CodingOpportunities/getCodingOpportunitiesPatients";
import { getCodingOpportunitiesByCip } from "../../../utils/services/APP/CodingOpportunities/getCodingOpportunitiesByCip";
import { useValidToken } from "../../../hooks/useValidToken";

export const CodingOpportunitiesContext = createContext();

export const CodingOpportunitiesProvider = ({ children }) => {
  const [CodingOpportunitiesPatients, setCodingOpportunitiesPatients] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);

  const [selectedCip, setSelectedCip] = useState(null);
  const [CodingOpportunitiesDetails, setCodingOpportunitiesDetails] = useState([]);

  const [page, setPage] = useState(0); // 0-based for MUI DataGrid
  const [pageSize, setPageSize] = useState(50);

  const { isValid, authLoading } = useValidToken();

  const fetchSummary = async () => {
    setLoading(true);
    try {
      console.log("contex")
      const res = await getCodingOpportunitiesPatients(page + 1, pageSize); // API espera 1-based
      setCodingOpportunitiesPatients(res.data.map((item) => ({ ...item, id: item.cipId })));
      setTotal(res.total);
    } catch (error) {
      console.error('[CodingOpportunitiesContext] Error loading summary:', error);
    }
    setLoading(false);
  };

  const fetchCodingOpportunitiesDetails = async (cipId) => {
    setDetailsLoading(true);
    try {
      const res = await getCodingOpportunitiesByCip(cipId);
      setCodingOpportunitiesDetails(res);
      setSelectedCip(cipId);
    } catch (error) {
      console.error("Error loading care gaps for CIP:", cipId, error);
    }
    setDetailsLoading(false);
  };

  useEffect(() => {
    if (!isValid || authLoading) return;
    fetchSummary();
  }, [page, pageSize, authLoading, isValid]);

  return (
    <CodingOpportunitiesContext.Provider
      value={{
        CodingOpportunitiesPatients,
        total,
        page,
        pageSize,
        loading,
        detailsLoading,
        CodingOpportunitiesDetails,
        selectedCip,
        setPage,
        setPageSize,
        fetchCodingOpportunitiesDetails,
        setSelectedCip
      }}
    >
      {children}
    </CodingOpportunitiesContext.Provider>
  );
};
